import React from "react";
import { Route, Switch, Redirect } from "react-router-dom";

import Dashboard from "../Routes/Manager/Dashboard/index";
import FeeSelect from "../Routes/Manager/FeeSelect/index";
import FeeEdit from "../Routes/Manager/Fee/Edit/index";
import FeeUsers from "../Routes/Manager/Fee/Users/index";
import FeeLedgers from "../Routes/Manager/Fee/Ledgers/index";
import FeeTaxInfo from "../Routes/Manager/Fee/TaxInfo/index";
import DonationSelect from "../Routes/Manager/DonationSelect/index";
import DonationEdit from "../Routes/Manager/Donation/Edit/index";
import DonationLedgers from "../Routes/Manager/Donation/Ledgers/index";
import DonationTaxInfo from "../Routes/Manager/Donation/TaxInfo/index";

const ManagerRoutes = ({
  userData,
  history,
  location,
  match,
  isModal,
  previousLocation,
}) => (
  <Switch location={isModal ? previousLocation : location}>
    {/* 요약 대시보드 (랜딩) */}
    <Route exact path="/dashboard">
      <Dashboard userData={userData} />
    </Route>

    {/* 담당 회비 목록 */}
    <Route exact path="/manager/fees">
      <FeeSelect userData={userData} />
    </Route>

    {/* 회비 정보 수정 */}
    <Route exact path="/manager/fees/:feeId/edit">
      <FeeEdit userData={userData} />
    </Route>

    {/* 회원목록 */}
    <Route exact path="/manager/fees/:feeId/users">
      <FeeUsers userData={userData} />
    </Route>

    {/* 거래내역 */}
    <Route exact path="/manager/fees/:feeId/ledgers">
      <FeeLedgers userData={userData} />
    </Route>

    {/* 주민번호 수집 현황 */}
    <Route exact path="/manager/fees/:feeId/taxInfos">
      <FeeTaxInfo userData={userData} />
    </Route>

    {/* 담당 기부 목록 */}
    <Route exact path="/manager/donations">
      <DonationSelect userData={userData} />
    </Route>

    {/* 기부 정보 수정 */}
    <Route exact path="/manager/donations/:donationId/edit">
      <DonationEdit userData={userData} />
    </Route>

    {/* 기부 내역 */}
    <Route exact path="/manager/donations/:donationId/ledgers">
      <DonationLedgers userData={userData} />
    </Route>

    {/* 기부 주민번호 수집 현황 */}
    <Route exact path="/manager/donations/:donationId/taxInfos">
      <DonationTaxInfo userData={userData} />
    </Route>

    <Redirect from="*" to="/dashboard" />
  </Switch>
);

export default ManagerRoutes;
